/**
 * @description: default layout
 */
export const LAYOUT = () => import('@/views/Main.vue')

export const PARENT_LAYOUT_NAME = 'ParentLayout'
export const REDIRECT_NAME = 'Redirect'
/**
 * @description: parent-layout
 */
export const getParentLayout = (_name?: string) => {
  // return () =>
  // new Promise((resolve) => {
  //   resolve({
  //     name: PARENT_LAYOUT_NAME
  //   })
  // })
  return () => import('@/layouts/page/index.vue')
}
